export type BrandSwatch = {name: string; value: string; row: 1 | 2};

/**
 * The accent palette, seven on the first row and four on the second beside the hex field.
 *
 * Lowercase is the canonical representation, as normalizeHexColor below produces — an accent
 * stored in one case and compared against the other reads as a custom colour.
 */
export const BRAND_SWATCHES: readonly BrandSwatch[] = [
	{name: 'Forecast Blue', value: '#0004db', row: 1},
	{name: 'Blush', value: '#feb6b3', row: 1},
	{name: 'Rose', value: '#ff8fd0', row: 1},
	{name: 'Orchid', value: '#d279e1', row: 1},
	{name: 'Violet', value: '#b27df7', row: 1},
	{name: 'Sky', value: '#addbff', row: 1},
	{name: 'Azure', value: '#75c2ff', row: 1},
	{name: 'Mint', value: '#3fecc4', row: 2},
	{name: 'Jade', value: '#27bb8f', row: 2},
	{name: 'Citron', value: '#f0ff9e', row: 2},
	{name: 'Amber', value: '#ffde85', row: 2},
];

/** What a quote starts from when the account has saved no branding default. */
export const DEFAULT_ACCENT_COLOR = BRAND_SWATCHES[0].value;

/** Accepts #RGB or #RRGGBB (leading # optional) and normalises to lowercase #rrggbb. */
export function normalizeHexColor(input: string): string | null {
	const raw = input.trim().replace(/^#/, '');
	if (/^[0-9a-fA-F]{6}$/.test(raw)) {
		return `#${raw.toLowerCase()}`;
	}
	if (/^[0-9a-fA-F]{3}$/.test(raw)) {
		return `#${raw
			.toLowerCase()
			.split('')
			.map(c => c + c)
			.join('')}`;
	}
	return null;
}
